<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *-->
<template>
  <div class="about">
    <s-header :name="'资讯'"></s-header>
    <div class="">

      <h1>{{content.name}}</h1>
      <div>发布时间：{{content.time}}</div>
      <van-divider/>
      <div class="about-body">
        <br>
        {{content.message}}</div>
    </div>
  </div>
</template>

<script>
import sHeader from '@/components/SimpleHeader'
import {useRoute} from "vue-router";
import {onMounted, reactive, toRefs} from "vue";
import {closeToast, showLoadingToast} from "vant";
import {contents} from "@/common/js/data";

export default {
  components: {
    sHeader
  }, setup() {
    const route = useRoute()

    const state = reactive({
      active: 0,
      nickName: '',
      introduceSign: '',
      loginName: '',
      password: '',
      column: '',
      content:{}
    })

    onMounted(async () => {
      await init()
    })


    const init = async () => {
      showLoadingToast({
        message: '加载中...',
        forbidClick: true
      });
      const {id} = route.query
      state.content = contents[id]

      closeToast()
    }


    const handleLogout = async () => {
      // const {resultCode} = await logout()
      // if (resultCode === 200) {
      //   setLocal('token', '')
      //   axios.defaults.headers['token'] = localStorage.getItem('token') || ''
      //   await router.push({"path": "/home"})
      //
      //   // window.location.href = '#/home'
      // }
    }

    return {
      ...toRefs(state),
      handleLogout
    }
  }

}
</script>

<style lang="less" scoped>
.about {
  box-sizing: border-box;
  padding: 20px;

  .intro-img {
    width: 100%;
  }

  .about-body {
    font-size: 12px;

    white-space: pre-line;

    a {
      color: #007fff;
    }
  }
}
</style>
